import endpoints from "hooks/api/endpoints";
import useApiGet, { UseApiGetOptions } from "hooks/api/useApiGet";
import IndividualItemResponse from "types/IndividualItemResponse";
import SignedUrlResponse from "types/SignedUrlResponse";

export default function useGetSignedAccountLogoUrl(
  accountId: string | null | undefined,
  options?: UseApiGetOptions,
) {
  const url = accountId ? endpoints.getSignedAccountLogoUrl(accountId) : null;

  const { result, ...rest } = useApiGet<
    IndividualItemResponse<SignedUrlResponse>
  >(url, options);

  return { signedLogoUrl: result?.data?.url, ...rest };
}
